// extracted by mini-css-extract-plugin
export default {"actions":"SendMessage_actions__E52jg","actionsButton":"SendMessage_actionsButton__qPYbe"};